
















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    data: function() {
        return {
            pathInStore: "transaction.availabilityPeriodType",
        };
    },
    computed: {
        availabilityPeriodType: function(): string {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("available"),
                    "value": "ON_THE_DATE"
                },
                {
                    "label": this.$t("immediately"),
                    "value": "IMMEDIATELY"
                },
                {
                    "label": this.$t("upon_exchange_of_deeds"),
                    "value": "UPON_EXCHANGE_OF_DEEDS"
                },
                {
                    "label": this.$t("to_be_defined"),
                    "value": "TO_BE_DEFINED"
                },
                {
                    "label": this.$t("at_delivery"),
                    "value": "AT_DELIVERY"
                },
                {
                    "label": this.$t("depending_on_the_tenant"),
                    "value": "DEPENDING_ON_THE_TENANT"
                }
            ];
        }
    },
    methods: {
        updateAvailability: function (value: string) {
            if (value != "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": value});

            } else if (value == "" &&
                this.$store.getters["FormModule/getValue"](this.pathInStore) != null
            ) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            }
        },
    }
});
